import { apiClient } from '@/config/api';

interface DashboardSummary {
    articles: {
        count: number;
        growthPercent: number | null;
    };
    comments: {
        count: number;
        growthPercent: number | null;
    };
    images: {
        count: number;
        growthPercent: number | null;
    };
    users: {
        count: number;
        growthPercent: number | null;
    };
    range: {
        current: {
            start: string;
            end: string;
        };
        previous: {
            start: string;
            end: string;
        };
    };
}

class DashboardService {
    async getSummary(): Promise<DashboardSummary> {
        const response: any = await apiClient.get<DashboardSummary>('/dashboard/summary');
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy tóm tắt số liệu dashboard');
        }
        return response.data;
    }
}

export const dashboardService = new DashboardService();
